module.exports = __webpack_public_path__ + "img/laba.a1807461.gif";